/** Rótulo do departamento responsável pelo ticket (campo `department_id` do ticket). */
export const DEPARTMENT_RESP_LABEL = 'Departamento'

export type QualityActiveProfile = {
  id: string
  name: string | null
  department_id?: string | null
  department?: { id: string; name?: string; display_name: string } | null
}

export type QualityRequesterRef = {
  id?: string
  name?: string | null
  department?: { display_name?: string; name?: string } | null
}

function resolveDepartmentName(
  requester?: QualityRequesterRef | null,
  profile?: QualityActiveProfile | null,
  departmentById?: Map<string, string>,
): string | undefined {
  return (
    requester?.department?.display_name ||
    requester?.department?.name ||
    profile?.department?.display_name ||
    profile?.department?.name ||
    (profile?.department_id ? departmentById?.get(profile.department_id) : undefined)
  )
}

function firstNameFromFullName(fullName: string): string {
  const part = fullName.trim().split(/\s+/)[0]
  return part || fullName.trim()
}

export type FormatRequesterDisplayOptions = {
  /** Lista de tickets: ex. João (TI) em vez de João Silva (TI). */
  firstNameOnly?: boolean
}

/** Ex.: João Silva (TI) ou João (TI) com `firstNameOnly` — departamento do cadastro (profiles.department_id). */
export function formatRequesterDisplay(
  requester?: QualityRequesterRef | null,
  profiles?: QualityActiveProfile[],
  departmentById?: Map<string, string>,
  requesterUserId?: string | null,
  options?: FormatRequesterDisplayOptions,
): string {
  const profileId = requester?.id || requesterUserId || null
  const profile = profileId && profiles?.length ? profiles.find(p => p.id === profileId) : undefined
  const name = (requester?.name || profile?.name || '').trim()
  if (!name) return '—'
  const displayName = options?.firstNameOnly ? firstNameFromFullName(name) : name
  const dept = resolveDepartmentName(requester, profile, departmentById)
  return dept ? `${displayName} (${dept})` : displayName
}

export function formatProfilePickerLabel(
  profile: QualityActiveProfile,
  departmentById?: Map<string, string>,
): string {
  return formatRequesterDisplay(profile, [profile], departmentById, profile.id)
}

export function buildDepartmentLabelMap(
  departments: { id: string; display_name?: string; name?: string }[],
): Map<string, string> {
  return new Map(departments.map(d => [d.id, d.display_name || d.name || d.id]))
}

/** Ex.: "12345 - João Corretor" */
export function formatBrokerTicketLabel(broker: { id_scgp: number | null; name: string } | null | undefined): string {
  if (!broker) return '—'
  const scgp = broker.id_scgp != null ? broker.id_scgp : '—'
  return `${scgp} - ${broker.name || '—'}`
}

/** Mantém somente dígitos em campos numéricos (policy_number, convenio_code). */
export function digitsOnlyInput(raw: string): string {
  return raw.replace(/\D/g, '')
}

export function parseOptionalDigitsField(raw: string): number | null {
  const digits = digitsOnlyInput(raw)
  if (!digits) return null
  const n = Number(digits)
  return Number.isSafeInteger(n) ? n : null
}

export function formatOptionalDigitsField(value: number | null | undefined): string {
  if (value == null) return ''
  return String(value)
}
